import { Title } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { DropboxLine } from "@dropbox/dig-icons/dist/mjs/assets";
import { PromotionQuerySuggestionContainer } from "@mirage/mosaics/Chat/components/chat/instructions/bridge_growth/PromotionQuerySuggestionContainer";
import { getTimeOfDayGreetingWithName } from "@mirage/mosaics/StartPage/Calendar/utils";
import { useName } from "@mirage/service-auth/useName";
import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";
import { useFeatureFlagValueBool } from "@mirage/service-experimentation/useFeatureFlagValue";
import { useIsSmallSizeForSidebar } from "@mirage/shared/responsive/mobile";
import i18n from "@mirage/translations";
import classNames from "classnames";
import { memo } from "react";
import styles from "./EmptyChatInstructions.module.css";

export const FSSEmptyChatInstructions = memo(() => {
  const { firstName } = useName();
  const isSmallSize = useIsSmallSizeForSidebar();
  const isDesktop = EnvCtx.surface === "desktop";
  const isFSSChatFTUXEnabled = useFeatureFlagValueBool(
    "bridge_growth_2025_06_26_fss_chat_ftux",
    true,
  );

  return (
    <div
      className={classNames(styles.EmptyChatInstructions, {
        [styles.Mobile]: isSmallSize,
        [styles.Desktop]: isDesktop,
      })}
    >
      <div
        className={classNames(styles.TitleContainer, {
          [styles.TitleContainerMobile]: isSmallSize,
        })}
      >
        <Box
          borderWidth="1"
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ width: "48px", height: "48px" }}
        >
          <UIIcon
            className={styles.EmptyChatIcon}
            size="large"
            src={DropboxLine}
          />
        </Box>
        <Title
          size="medium"
          weightVariant="emphasized"
          className={styles.Title}
        >
          {getTimeOfDayGreetingWithName(firstName)}
        </Title>
        <Title
          size="medium"
          weightVariant="emphasized"
          className={styles.Subtitle}
        >
          {i18n.t("assistant_empty_chat_subtitle")}
        </Title>
        {isFSSChatFTUXEnabled && <PromotionQuerySuggestionContainer />}
      </div>
    </div>
  );
});

FSSEmptyChatInstructions.displayName = "FSSEmptyChatInstructions";
